import React, { ReactNode } from 'react'
import styles from './CardContentContainer.module.scss'
import { Card } from '@plurall/elo-beta'

type CardContentContainerProps = {
  children: ReactNode
}

const CardContentContainer = ({ children }: CardContentContainerProps) => {
  return (
    <div className={styles['card-container']}>
      <Card style={{ width: '100%' }}>
        <div className={styles.content}>{children}</div>
      </Card>
    </div>
  )
}

export default CardContentContainer
